import { Component,OnInit } from '@angular/core';
import {ImmaginiMortiService} from '../services/immagini-morti.service';
import {Immagine} from '../beans/immagine';

@Component({
  selector: 'catalogo-immagini-morti-component',
  templateUrl: './catalogo-immagini-morti.component.html',
  styleUrls: ['./catalogo-immagini-morti.component.css']
})
export class CatalogoImmaginiMortiComponent implements OnInit {
  
  immagini:Immagine[];

  constructor (private immaginiMortiService:ImmaginiMortiService){}

  ngOnInit():void{
  	this.immaginiMortiService.getImmagini().then(immagini=>this.immagini=immagini);
  }
}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/catalogo/catalogo-immagini-morti.component.ts